import { Link, useRouteError } from "react-router-dom";

import ContactSupportButton from "@/components/ContactSupportButton";
import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

export default function RouteError() {
  const error = useRouteError();

  return (
    <div className="my-auto flex h-screen flex-col items-center justify-center">
      <div className="mb-4 flex items-center gap-4">
        <Link to="/">Go to homepage</Link>
        <Button onClick={() => window.location.reload()}>Try Reload</Button>
        <ContactSupportButton subject={`WebCrash&body=${error?.toString()}`} />
      </div>
      <Typography weight="semibold" variant="display-xs">
        App crashed due to next error
      </Typography>
      <Typography className="max-w-[600px]">{error?.toString()}</Typography>
    </div>
  );
}
